import { HStack, Icon, StackProps, Text, VStack } from "@chakra-ui/react";
import { PageIconNavsProps } from "../../constants/PageNavs";
import { SidebarButton } from "../button/SidebarButton";

interface Props extends StackProps {
  children: any;
  navs: PageIconNavsProps[];
}

export const PageContainer = ({ children, navs, ...rest }: Props) => {
  return (
    <VStack
      className="page-container"
      w={"100%"}
      h={"100%"}
      minH={"calc(100dvh - 60px)"}
      p={4}
      align={"stretch"}
      {...rest}
    >
      <HStack gap={4}>
        {navs.map((item) => (
          <SidebarButton
            end={true}
            key={item.id}
            w={"fit-content"}
            to={item.to}
            _activeLink={{
              bg: "red.100",
              color: "red.400",
            }}
          >
            <HStack alignItems={"center"}>
              <Icon as={item.icon} fontSize={[14, null, 16]} />

              <Text textStyle={"b-reg-sb"}>{item.label}</Text>
            </HStack>
          </SidebarButton>
        ))}
      </HStack>

      {children}
    </VStack>
  );
};
